import React from "react";
import { JobSearchHit } from "@themuse/design-system";
import { useAppState } from "hooks/AppContext";
import { getJobTrackingProps } from "utils/tracking";
import { SidebarJobTile } from "./SidebarJobTile";

import styles from "./JobIndividualSidebar.module.scss";
import { SingleCompany, SingleJob } from "interfaces/api/apiInterfaces";

export const SimilarJobsSidebar = () => {
    const { job, similarJobs } = useAppState();
    // We only ever want a max of three jobs, and we don't want to include the job we are displaying, so we request 4 and filter it out
    const tiles = similarJobs?.hits?.filter((searchHit: JobSearchHit) => searchHit.hit.legacy_id !== job.id).slice(0, 3).map((searchHit: JobSearchHit, index: number) => {
        const { hit } = searchHit;
        const { company } = hit;
        const trackingProps = {
            ...getJobTrackingProps(hit as undefined as SingleJob, company as undefined as SingleCompany),
            ...{
                placement_position: "job detail page",
                placement: "Individual Job",
                order_num: index + 1,
                recommended: true,
            }
        };

        return (
            <SidebarJobTile
                key={hit.id}
                jobSearchData={hit}
                orderNum={index + 1}
                data-tracking-event-type="impression"
                data-tracking-props={JSON.stringify(trackingProps)}
            />
        );
    });

    return (
        similarJobs?.hits?.length ? (
            <div className={styles.similarJobsModule}>
                <h2>Similar Jobs</h2>
                <ul>
                    { tiles }
                </ul>
            </div>
        ) : null
    );
};
